import { Bot, TrendingUp, Braces, Smartphone, Megaphone, UtensilsCrossed } from "lucide-react";
import { FadeUp, SectionLabel } from "./Reveal";

const CAPS = [
  {
    icon: Bot,
    title: "AI Agents & Automation",
    desc: "WhatsApp AI agents, AI calling, lead qualification pipelines and 24/7 digital workforces that never stop working.",
  },
  {
    icon: TrendingUp,
    title: "Algorithmic Trading",
    desc: "Gold scalping EAs, MT5 trading systems, Capital-First risk engines and autonomous market intelligence.",
  },
  {
    icon: Braces,
    title: "Custom SaaS & Platforms",
    desc: "Enterprise-grade web platforms, dashboards, CRM systems and cloud software engineered to scale.",
  },
  {
    icon: Smartphone,
    title: "Mobile & Web Apps",
    desc: "iOS & Android apps, signal platforms, copy-trading systems and portfolio tools with premium UX.",
  },
  {
    icon: Megaphone,
    title: "Growth & Marketing",
    desc: "Digital marketing, automated funnels and growth systems that compound — powered by data, not guesswork.",
  },
  {
    icon: UtensilsCrossed,
    title: "Food & Hospitality",
    desc: "Cloud kitchens and premium food brands built on real ingredients, hygiene and honest flavour.",
  },
];

export const Capabilities = () => (
  <section id="capabilities" data-testid="capabilities-section" className="relative py-24 md:py-32">
    <div className="pointer-events-none absolute right-0 top-40 h-96 w-96 rounded-full bg-cyan-500/10 blur-[150px]" />
    <div className="mx-auto max-w-[1440px] px-6 md:px-12">
      <FadeUp>
        <SectionLabel>What We Do</SectionLabel>
      </FadeUp>
      <div className="mt-6 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <FadeUp delay={0.1}>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Capabilities across
            <br />
            <span className="text-gradient-cyan">every frontier.</span>
          </h2>
        </FadeUp>
        <FadeUp delay={0.2}>
          <p className="max-w-md text-base leading-relaxed text-slate-400">
            From autonomous AI to autonomous trading — and from enterprise
            software to the dinner table.
          </p>
        </FadeUp>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {CAPS.map((c, i) => (
          <FadeUp key={c.title} delay={(i % 3) * 0.1}>
            <div
              data-testid={`capability-card-${i}`}
              className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-slate-950/60 p-8 backdrop-blur-xl transition-[border-color,box-shadow] duration-300 hover:border-cyan-400/40 hover:shadow-[0_0_30px_rgba(0,229,255,0.1)]"
            >
              <span className="pointer-events-none absolute -right-3 -top-6 font-display text-8xl font-extrabold text-white/[0.04] transition-colors duration-500 group-hover:text-cyan-400/10">
                {String(i + 1).padStart(2, "0")}
              </span>
              <span className="flex h-13 w-13 items-center justify-center rounded-xl border border-white/10 bg-gradient-to-br from-blue-500/20 to-cyan-400/10 p-3 transition-transform duration-300 group-hover:scale-110">
                <c.icon className="h-6 w-6 text-cyan-400" />
              </span>
              <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-white">
                {c.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-400">{c.desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
